import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./user-profile.scss";
import { IconFirm24 } from "../Icons/Icons";
import Avatar from "../Avatar/Avatar";

const UserProfile = ({ name, initials, userType, userTypeText, hideName, className, ...props }) => {
  const getColour = () => {
    switch (userType.toLowerCase()) {
      case "affiliate":
      case "graduate":
      case "student":
        return "grey";
      case "fellow":
      case "member":
        return "red";
      case "firm":
        return "black";
      default:
        return "red";
    }
  };

  const colour = getColour();

  return (
    <div className={classnames("user-profile", className)} {...props}>
      <Avatar
        colour={colour}
        text={userTypeText}
        initials={userType !== "firm" && initials}
        icon={userType === "firm" && IconFirm24}
      />
      {!hideName && !!name && <div className="user-profile__name">{name}</div>}
    </div>
  );
};

UserProfile.propTypes = {
  userType: PropTypes.oneOf(["affiliate", "firm", "student", "member"]).isRequired,
  userTypeText: PropTypes.string.isRequired,
  name: PropTypes.string,
  initials: PropTypes.string,
  className: PropTypes.string,
  hideName: PropTypes.bool,
};

export default UserProfile;
